import { render, staticRenderFns } from "./FireWhoIsResponsible.vue?vue&type=template&id=fe610544&scoped=true"
import script from "./FireWhoIsResponsible.vue?vue&type=script&lang=ts"
export * from "./FireWhoIsResponsible.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe610544",
  null
  
)

export default component.exports